import React from "react";
import { useTranslation } from "react-i18next";

export const STATUS_CONFIG = {
    pending_approval: { label: "Wacht op goedkeuring", color: "#F59E0B", bg: "rgba(245,158,11,0.1)" },
    approved_scheduled: { label: "Ingepland", color: "#3B82F6", bg: "rgba(59,130,246,0.1)" },
    in_production: { label: "In productie", color: "#8B5CF6", bg: "rgba(139,92,246,0.1)" },
    review_needed: { label: "Heeft review nodig", color: "#E5A93D", bg: "rgba(229,169,61,0.1)" },
    delivered: { label: "Opgeleverd", color: "#10B981", bg: "rgba(16,185,129,0.1)" },
    rejected: { label: "Afgewezen", color: "#EF4444", bg: "rgba(239,68,68,0.1)" },
};

export default function StatusBadge({ status }) {
    const { t } = useTranslation();
    const key = STATUS_CONFIG[status] ? status : "pending_approval";
    const cfg = STATUS_CONFIG[key];
    return (
        <span
            data-testid={`status-badge-${status}`}
            className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-sm text-[10px] font-bold uppercase tracking-wider border"
            style={{ color: cfg.color, backgroundColor: cfg.bg, borderColor: `${cfg.color}33` }}
        >
            <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: cfg.color }} />
            {t(`status.${key}`, cfg.label)}
        </span>
    );
}
